<template>
  <div>
    <section class="section main-section">
      <nav-bar></nav-bar>
      <div class="container">
        <div>
          <div class="columns is-desktop">
            <div class="column is-two-thirds element">
              <router-view :key="$route.path"></router-view>
            </div>

            <div class="column">
              <div class="columns is-multiline">
                <div class="column element">
                  <h3 class="subtitle">Grupa Zbieraj Monety na Facebooku</h3>

                  <table border="0" width="100%" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
                    <tr style>
                      <td height="28" style="line-height:28px;">&nbsp;</td>
                    </tr>
                    <tr>
                      <td style>
                        <table border="0" width="280" cellspacing="0" cellpadding="0"
                          style="border-collapse:separate;background-color:#ffffff;border:1px solid #dddfe2;border-radius:3px;font-family:Helvetica, Arial, sans-serif;margin:0px auto;">
                          <tr>
                            <td style="font-size:14px;font-weight:bold;padding:8px 8px 0px 8px;text-align:center;">Zbieraj
                              Monety</td>
                          </tr>
                          <tr>
                            <td style="color:#90949c;font-size:12px;font-weight:normal;text-align:center;">Grupa Prywatna
                              · {{ fbGroupMemebersCount }} członków</td>
                          </tr>
                          <tr>
                            <td style="padding:8px 12px 12px 12px;">
                              <table border="0" cellspacing="0" cellpadding="0"
                                style="border-collapse:collapse;width:100%;">
                                <tr>
                                  <td>
                                    <a style="color:#3b5998;text-decoration:none;cursor:pointer;width:100%;"
                                      href="https://facebook.com/groups/zbierajmonety/" target="_blank" rel="noopener">
                                      <table border="0" cellspacing="0" cellpadding="3" align="center"
                                        style="border-collapse:collapse;">
                                        <tr>
                                          <td>
                                            <button class="button is-primary">
                                              <span class="icon">
                                                <i class="fab fa-facebook" aria-hidden="true"></i>
                                              </span>
                                              <span>Dołącz do grupy</span>
                                            </button>
                                          </td>
                                        </tr>
                                      </table>
                                    </a>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td style="border-top:1px solid #dddfe2;font-size:12px;padding:8px 12px;">Grupa o Monetach
                              Inwestycyjnych. Handlujemy, uczymy się i wrzucamy linki.</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr style>
                      <td height="28" style="line-height:28px;">&nbsp;</td>
                    </tr>
                  </table>
                </div>

                <div class="column element">
                  <h3 class="subtitle">Najnowszy Artykuł</h3>

                  <div class="columns is-multiline">
                    <div class="column is-12" v-for="article in articles.slice(0, 1)" :key="article.slug">
                      <article-widget :article="article"></article-widget>
                    </div>
                  </div>
                </div>

                <div class="column element">
                  <!-- List of coins details: -->
                  <h3 class="subtitle">Popularne monety</h3>

                  <product-widget v-for="product in popularProducts" :key="'side-widget-' + product.slug + product.metal"
                    :product="product" :isSide="true"></product-widget>
                </div>

                <div class="column element">
                  <h3 class="subtitle">Zobacz porównania {{ popularProducts[0].name }}</h3>

                  <compare-widget v-for="product2 in productsWoSlug(popularProducts[0].slug)"
                    :key="product2.slug + product2.metal" :product1="popularProducts[0]"
                    :product2="product2"></compare-widget>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <cookie-law buttonText="Akceptuję">
      <div slot="message">
        Informujemy, iż w celu udostępnienia funkcjonalności dostępnych na naszej stronie, optymalizacji jej treści oraz
        dostosowania strony do Państwa indywidualnych potrzeb korzystamy z informacji zapisanych za pomocą plików cookies
        na urządzeniach końcowych użytkowników. Pliki cookies można kontrolować za pomocą ustawień swojej przeglądarki
        internetowej. Dalsze korzystanie z naszej strony internetowej, bez zmiany ustawień przeglądarki internetowej
        oznacza, iż użytkownik akceptuje stosowanie plików cookies. Więcej informacji zawartych jest w
        <a href="/static/Polityka_Prywatnosci_zbierajmonety.pdf">polityce prywatności strony</a>.
      </div>
    </cookie-law>
    <footer-section></footer-section>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";

import json from "./database.json";
import articles from "./articles.json";

import ArticleWidget from "./components/ArticleWidget";
import CompareWidget from "./components/CompareWidget";
import FooterSection from "./components/FooterSection";
import NavBar from "./components/NavBar";
import ProductWidget from "./components/ProductWidget";

export default {
  metaInfo() {
    return {
      title: "ZbierajMonety.pl - Portal o inwestowaniu w Monety Bulionowe ",
      // titleTemplate: "%s | ZbierajMonety.pl"
    };
  },
  data() {
    return {
      products: json,
      database: {},
    };
  },
  methods: {
    productsWoSlug(excludeSlug) {
      return this.popularProducts.filter((item) => item.slug != excludeSlug);
    },
    getRandomSubarray(arr, size) {
      var shuffled = arr.slice(0),
        i = arr.length,
        min = i - size,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
  },
  computed: {
    popularProducts() {
      return this.getRandomSubarray(this.products, 4);
    },
    articles() {
      return articles.filter((art) => art.isPublic);
    },
  },
  created() {
    // prepare database:

    this.database = {};
    for (var i in json) {
      var elem = json[i];
      this.database[elem.slug] = elem;
    }
  },
  components: {
    ArticleWidget,
    CompareWidget,
    FooterSection,
    NavBar,
    ProductWidget,
    CookieLaw,
  },
};
</script>

<style>
/*! debug.css v0.0.3 | MIT License | https://gist.github.com/zaydek/6b2e55258734deabbd2b4a284321d6f6 */
[debug],
[debug] * {
  color: hsla(210, 100%, 100%, 0.9) !important;
  background: hsla(210, 100%, 50%, 0.5) !important;
  outline: solid 0.25rem hsla(210, 100%, 100%, 0.5) !important;

  box-shadow: none !important;
  filter: none !important;
}

@media all and (max-width: 768px) {
  .main-section {
    padding: 0 !important;
  }
}

.element {
  background-color: white;
  border-radius: 4px;
  padding: 1rem 1rem 1rem 1.5rem !important;
  margin: 0.5rem;
}

@media all and (max-width: 768px) {
  .element {
    padding: 2rem 1rem 1rem 1rem !important;
    margin: 0 0 0 0.5rem;
  }
}
</style>
